var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHoliday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE8\x8A\x82\xE5\x81\x87\xE6\x97\xA5\xE7\xAE\xA1\xE7\x90\x86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE6\xA4\xAD\xE5\x9C\x86\xE5\xBD\xA2",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#9581FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    d: "M24 10.368C24 9.81573 23.5524 9.368 23 9.368H19.617V8.5C19.6118 8.22753 19.3895 8.00934 19.117 8.00934C18.8445 8.00934 18.6221 8.22753 18.617 8.5V9.368H13.055V8.5C13.055 8.22386 12.8312 8 12.555 8C12.2789 8 12.055 8.22386 12.055 8.5V9.368H9C8.44773 9.368 8 9.81573 8 10.368V12.879H24V10.368ZM8 13.879V23C8 23.5524 8.44773 24 9 24H23C23.5524 24 24 23.5524 24 23V13.879H8ZM20.8439 20.312C20.775 20.39 20.6811 20.4311 20.537 20.554L19.2769 21.454C18.8839 21.6815 18.4016 21.6909 18 21.479L11.73 18.1721C11.248 17.943 10.828 17.4471 11.099 16.8491L11.104 16.841C11.425 16.235 12.127 16.247 12.58 16.4531L14.782 17.602L18.039 16.1482C18.342 16.0081 18.418 15.9371 18.7029 16.118L19.095 16.435C19.3009 16.6141 19.323 16.818 19.1829 16.9732C19.1279 17.0341 19.099 17.053 19.018 17.126L16.982 18.791L18.7561 19.7741L20.082 19.5601C20.463 19.4631 20.51 19.5381 20.686 19.6991L20.883 19.879C21.0891 20.078 20.935 20.2091 20.8439 20.312Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoliday);
export default __webpack_public_path__ + "static/media/holiday.42c0b8a26faca618c0fc93562f47a56f.svg";
export { ForwardRef as ReactComponent };